import { Box } from "@chakra-ui/react";
import { useEffect, useState } from "react";

import BuscadorDesktop from "@/components/home/Busqueda/BuscadorDesktop";

import AnimatedCarousel from "./AnimatedCarousel";

export const Hero = (props) => {
    const slides = [
        {
            key: "vcolomos",
            icon: "https://media.grupoguia.mx/assets/home-page/bgsHero/2026/agosto/VistaColomos_logo.svg",
            imageUrl:
                "https://media.grupoguia.mx/assets/home-page/bgsHero/2026/agosto/VistaColomos.jpg",
            text: "Vista Colomos • Zapopan, Jal.",
            subtitle: "Estudios, 1, 2 y 3 recámaras en preventa Desde $3,950,000 MXN*",
        },
        {
            key: "sivi",
            icon: "https://media.grupoguia.mx/assets/home-page/bgsHero/2026/agosto/Sivi_logo.svg",
            imageUrl: "https://media.grupoguia.mx/assets/home-page/bgsHero/2026/agosto/Sivi.jpg",
            text: "Sivi Americana Co-living • Guadalajara, Jal.",
            subtitle: "Conoce la nueva forma de invertir   •   Ticket desde $917,000 MXN*",
        },
        {
            key: "ontario",
            icon: "https://media.grupoguia.mx/assets/home-page/bgsHero/2025/Diciembre/OntarioLogo.svg",
            imageUrl:
                "https://media.grupoguia.mx/assets/home-page/bgsHero/2025/Diciembre/Ontario.webp",
            text: "Ontario 1789 • Guadalajara, Jal..",
            subtitle: "Departamentos y townhouses en preventa. De 2, 3 y 4 recámaras.",
            subtitle2: "Desde: $13,977,470.80*",
        },
        {
            key: "guialink",
            icon: "https://media.grupoguia.mx/assets/home-page/bgsHero/2025/Marzo/logo-5.svg",
            imageUrl:
                "https://media.grupoguia.mx/assets/home-page/bgsHero/2025/Marzo/banner-5.webp",
            text: "Compra la propiedad de tus sueños",
            subtitle: "con el crédito hipotecario ideal para ti",
            link: "https://grupoguia.mx/guialink",
        },
    ];
    //Elementos para responsive
    const [current, setCurrent] = useState(0);
    const [dotClicked, _setDotClicked] = useState(false);
    const [_showFlotantCard, setShowFlotantCard] = useState(true);

    useEffect(() => {
        if (!dotClicked) {
            const intervalId = setInterval(() => {
                if (current === slides.length - 1) {
                    setCurrent(0);
                } else {
                    if (!dotClicked) {
                        setCurrent(current + 1);
                    }
                }
            }, 5000);

            return () => clearInterval(intervalId);
        }
    }, [current, dotClicked, slides.length]);

    // ==== FUNCITON TO SHOW AND HIDE THE FLOTANT BANNER ====
    useEffect(() => {
        function handleScroll() {
            if (window.pageYOffset > 150) {
                setShowFlotantCard(false);
            } else {
                setShowFlotantCard(true);
            }
        }

        window.addEventListener("scroll", handleScroll);

        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <Box w="full" mx="auto" maxW="3x1" {...props} paddingInline="0" position="relative">
            <AnimatedCarousel slides={slides}>
                <BuscadorDesktop />
            </AnimatedCarousel>
        </Box>
    );
};

export default Hero;
